<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" by-operator :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('operatorJourneyStatsReport.title') }}</h2>
      <p class="text-center mb-3 no-print">
        {{ $t('operatorJourneyStatsReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && reportEnvelope" class="row ">
      <div class="col-6">
        <card :title="$t('operatorJourneyStatsReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorJourneyStatsReport.summary.operator') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.operatorName }}
                ({{ reportEnvelope.operatorId }})</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorJourneyStatsReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.generated_at | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('operatorJourneyStatsReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportEnvelope.from | dateOnly }} - {{
                  reportEnvelope.to |
                    dateOnly
                }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <template slot="header">
            <h4 class="card-title">{{ $t(`operatorJourneyStatsReport.allJourneysResults.title`) }}
              <small v-if="reportEnvelope" class="ml-2 text-muted">({{ reportEnvelope.from | dateOnly }} - {{
                  reportEnvelope.to | dateOnly
                }})</small>
            </h4>
            <p class="card-subtitle text-muted mb-2">{{
                $t(`operatorJourneyStatsReport.allJourneysResults.subTitle`)
              }}</p>
          </template>
          <el-table
            :data="allJourneysData"
            row-key="id"
            show-summary :summary-method="getAllJourneysStatsTableTotal">
            <el-table-column
              prop="discount">
              <template slot-scope="{ row }">{{
                  $t(`discountTypes.${row.discount}`)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="non_free_journeys"
              :label="$t(`operatorJourneyStatsReport.allJourneysResults.non_free_journeys`)">
            </el-table-column>
            <el-table-column
              prop="free_journeys"
              :label="$t(`operatorJourneyStatsReport.allJourneysResults.free_journeys`)">
            </el-table-column>
            <el-table-column
              :label="$t(`operatorJourneyStatsReport.allJourneysResults.total_journeys`)">
              <template slot-scope="{ row }">{{ row.non_free_journeys + row.free_journeys }}</template>
            </el-table-column>
            <el-table-column
              :label="$t(`operatorJourneyStatsReport.allJourneysResults.charge`)">
              <template slot-scope="{ row }">{{ row.charge | money }}</template>
            </el-table-column>
          </el-table>

        </card>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope" class="row mt-3">
      <div class="col-md-4">
        <card card-body-classes="table-full-width">
          <template slot="header">
            <h4 class="card-title">{{ $t(`operatorJourneyStatsReport.changeJourneysResults.title`) }}
              <small v-if="reportEnvelope" class="ml-2 text-muted">({{ reportEnvelope.from | dateOnly }} - {{
                  reportEnvelope.to | dateOnly
                }})</small>
            </h4>
            <p class="card-subtitle text-muted mb-2">
              {{ $t(`operatorJourneyStatsReport.changeJourneysResults.subTitle`) }}</p>
          </template>
          <el-table
            :data="changeJourneysData"
            row-key="id"
            show-summary :summary-method="getCommonTableTotal">
            <el-table-column
              prop="discount">
              <template slot-scope="{ row }">{{
                  $t(`discountTypes.${row.discount}`)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="journeys"
              :label="$t(`operatorJourneyStatsReport.changeJourneysResults.journeys`)">
            </el-table-column>
          </el-table>

        </card>
      </div>
      <div class="col-md-4">
        <card card-body-classes="table-full-width">
          <template slot="header">
            <h4 class="card-title">{{ $t(`operatorJourneyStatsReport.monthTicketUseJourneysResults.title`) }}
              <small v-if="reportEnvelope" class="ml-2 text-muted">({{ reportEnvelope.from | dateOnly }} - {{
                  reportEnvelope.to | dateOnly
                }})</small>
            </h4>
            <p class="card-subtitle text-muted mb-2">{{
                $t(`operatorJourneyStatsReport.monthTicketUseJourneysResults.subTitle`)
              }}</p>
          </template>
          <el-table
            :data="monthTicketUseJourneysData"
            row-key="id"
            show-summary :summary-method="getCommonTableTotal">
            <el-table-column
              prop="discount">
              <template slot-scope="{ row }">{{
                  $t(`discountTypes.${row.discount}`)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="journeys"
              :label="$t(`operatorJourneyStatsReport.monthTicketUseJourneysResults.journeys`)">
            </el-table-column>
          </el-table>

        </card>
      </div>

      <div class="col-md-4">
        <card card-body-classes="table-full-width">
          <template slot="header">
            <h4 class="card-title">{{ $t(`operatorJourneyStatsReport.seasonalTicketJourneysResults.title`) }}
              <small v-if="reportEnvelope" class="ml-2 text-muted">({{ reportEnvelope.from | dateOnly }} - {{
                  reportEnvelope.to | dateOnly
                }})</small>
            </h4>
            <p class="card-subtitle text-muted mb-2">{{
                $t(`operatorJourneyStatsReport.seasonalTicketJourneysResults.subTitle`)
              }}</p>
          </template>
          <el-table
            :data="seasonalTicketJourneysData"
            row-key="id"
            show-summary :summary-method="getCommonTableTotal">
            <el-table-column
              prop="discount">
              <template slot-scope="{ row }">{{
                  $t(`discountTypes.${row.discount}`)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="journeys"
              :label="$t(`operatorJourneyStatsReport.seasonalTicketJourneysResults.journeys`)">
            </el-table-column>
          </el-table>

        </card>
      </div>
    </div>

    <div v-if="loading === false && !error && reportEnvelope" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <template slot="header">
            <h4 class="card-title">{{ $t(`operatorJourneyStatsReport.freeTariffJourneysResults.title`) }}
              <small v-if="reportEnvelope" class="ml-2 text-muted">({{ reportEnvelope.from | dateOnly }} - {{
                  reportEnvelope.to | dateOnly
                }})</small>
            </h4>
            <p class="card-subtitle text-muted mb-2">{{
                $t(`operatorJourneyStatsReport.freeTariffJourneysResults.subTitle`)
              }}</p>
          </template>
          <el-table
            :data="freeTariffJourneysData"
            row-key="id"
            show-summary :summary-method="getFreeTariffJourneysTableTotal">
            <el-table-column
              prop="discount">
              <template slot-scope="{ row }">{{
                  $t(`discountTypes.${row.discount}`)
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="journeys_without_change"
              :label="$t(`operatorJourneyStatsReport.freeTariffJourneysResults.journeys_without_change`)">
            </el-table-column>
            <el-table-column
              prop="journeys_with_change"
              :label="$t(`operatorJourneyStatsReport.freeTariffJourneysResults.journeys_with_change`)">
            </el-table-column>
            <el-table-column
              :label="$t(`operatorJourneyStatsReport.freeTariffJourneysResults.total_journeys`)">
              <template slot-scope="{ row }">{{ row.journeys_without_change + row.journeys_with_change }}</template>
            </el-table-column>
          </el-table>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert} from 'src/components';
import DetailedReportPeriod from 'src/components/DetailedReportPeriod/DetailedReportPeriod';
import {mapActions, mapState} from "vuex";
import ReportFilter from "./ReportFilter";

export default {
  name: 'journeys-stats-report',
  components: {
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    DetailedReportPeriod,
    ReportFilter
  },
  data() {
    return {
      tickets: [],
      reportEnvelope: null,
      allJourneysData: [],
      changeJourneysData: [],
      monthTicketUseJourneysData: [],
      seasonalTicketJourneysData: [],
      freeTariffJourneysData: [],
      vehicleTypes: ['bus', 'trolleybus', 'funicular', 'boat'] //, 'tram', 'train', 'ferry']
    };
  },
  computed: {
    ...mapState({
      loading: state => state.operator_journey_stats_report.loading,
      error: state => state.operator_journey_stats_report.error,
      data: state => state.operator_journey_stats_report.data,
    }),
  },
  methods: {
    ...mapActions(['LoadOperatorJourneysStatsReport']),

    reloadReport(query) {
      this.LoadOperatorJourneysStatsReport(query);
    },
    getAllJourneysStatsTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t(`operatorJourneyStatsReport.commonResults.rowTotal`);
          return;
        }
        let values;
        if (index === 3) {
          values = data.map(item => Number(item['free_journeys'])).concat(data.map(item => Number(item['non_free_journeys'])));
        } else if (index === 4) {
          values = data.map(item => Number(item['charge']));
        } else {
          values = data.map(item => Number(item[column.property]));
        }

        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);

          if (index == 4) {
            sums[index] = this.$options.filters['money'](sums[index]);
          }
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    getCommonTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t(`operatorJourneyStatsReport.commonResults.rowTotal`);
          return;
        }
        const values = data.map(item => Number(item[column.property]));

        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    getFreeTariffJourneysTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t(`operatorJourneyStatsReport.commonResults.rowTotal`);
          return;
        }
        let values;
        if (index === 3) {
          values = data.map(item => Number(item['journeys_without_change'])).concat(data.map(item => Number(item['journeys_with_change'])));
        } else {
          values = data.map(item => Number(item[column.property]));
        }

        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    prepareAllJourneysData(data) {
      // IdIDX - key for `vue`.
      let idIdx = 0;
      for (let i in this.vehicleTypes) {
        let vt = {
          id: 'all_' + ++idIdx,
          discount: "operatorJourneyStatsReport_in_" + this.vehicleTypes[i],
          free_journeys: 0,
          non_free_journeys: 0,
          charge: 0,
          children: []
        };

        data.all_journeys[this.vehicleTypes[i]].map((item) => {
          vt.free_journeys = vt.free_journeys + item.free_journeys;
          vt.non_free_journeys = vt.non_free_journeys + item.non_free_journeys;
          vt.charge = vt.charge + item.charge;
          item["id"] = 'all_' + ++idIdx;
          vt.children.push(item);
        })
        this.allJourneysData.push(vt);
      }
    },
    prepareChangeJourneys(data) {
      // IdIDX - key for `vue`.
      let idIdx = 0;
      for (let i in this.vehicleTypes) {
        let vt = {
          id: 'free_' + ++idIdx,
          discount: "operatorJourneyStatsReport_in_" + this.vehicleTypes[i],
          journeys: 0,
          children: []
        };

        data.change_journeys[this.vehicleTypes[i]].map((item) => {
          vt.journeys = vt.journeys + item.journeys;
          item["id"] = 'free_' + ++idIdx;
          vt.children.push(item);
        })
        this.changeJourneysData.push(vt);
      }
    },
    prepareMonthTicketUse(data) {
      // IdIDX - key for `vue`.
      let idIdx = 0;
      for (let i in this.vehicleTypes) {
        let vt = {
          id: 'month_' + ++idIdx,
          discount: "operatorJourneyStatsReport_in_" + this.vehicleTypes[i],
          journeys: 0,
          children: []
        };

        data.month_ticket_use_journeys[this.vehicleTypes[i]].map((item) => {
          vt.journeys = vt.journeys + item.journeys;
          item["id"] = 'month_' + ++idIdx;
          vt.children.push(item);
        })
        this.monthTicketUseJourneysData.push(vt);
      }
    },
    prepareSeasonalTicketUse(data) {
      // IdIDX - key for `vue`.
      let idIdx = 0;
      for (let i in this.vehicleTypes) {
        let vt = {
          id: 'seasonal_' + ++idIdx,
          discount: "operatorJourneyStatsReport_in_" + this.vehicleTypes[i],
          journeys: 0,
          children: []
        };

        data.seasonal_ticket_journeys[this.vehicleTypes[i]].map((item) => {
          vt.journeys = vt.journeys + item.journeys;
          item["id"] = 'seasonal_' + ++idIdx;
          vt.children.push(item);
        })
        this.seasonalTicketJourneysData.push(vt);
      }
    },
    prepareFreeTariffJourneysData(data) {
      // IdIDX - key for `vue`.
      let idIdx = 0;
      for (let i in this.vehicleTypes) {
        let vt = {
          id: 'free_' + ++idIdx,
          discount: "operatorJourneyStatsReport_in_" + this.vehicleTypes[i],
          journeys_without_change: 0,
          journeys_with_change: 0,
          children: []
        };

        data.free_tariff_journeys[this.vehicleTypes[i]].map((item) => {
          vt.journeys_without_change = vt.journeys_without_change + item.journeys_without_change;
          vt.journeys_with_change = vt.journeys_with_change + item.journeys_with_change;
          item["id"] = 'free_' + ++idIdx;
          vt.children.push(item);
        })
        this.freeTariffJourneysData.push(vt);
      }
    },
    prepareReportData(data) {
      if (!data) {
        this.reportEnvelope = null;
        this.allJourneysData = [];
        this.changeJourneysData = [];
        this.monthTicketUseJourneysData = [];
        this.seasonalTicketJourneysData = [];
        this.freeTariffJourneysData = [];
        return
      }

      this.reportEnvelope = {
        from: data.from,
        to: data.to,
        generated_at: data.generated_at,
        operatorId: data.operatorId,
        operatorName: data.operatorName,
      }

      this.prepareAllJourneysData(data)
      this.prepareChangeJourneys(data)
      this.prepareMonthTicketUse(data)
      this.prepareSeasonalTicketUse(data)
      this.prepareFreeTariffJourneysData(data)
    },
  },
  mounted() {
    this.prepareReportData(this.data)
  },
  watch: {
    data(data) {
      this.prepareReportData(data)
    }
  }
};
</script>
